import component from './toolsI18nWizardsGroup.vue'
export default component
